'use client';
import ImageOptimizer from '@/components/image-optimizer';
import Pagination from '@/components/pagination';
import PoliceLineDivider from '@/components/police-line-divider';
import { eventPromotionBannerData } from '@/data/event/event.data';
import { ListContainer } from '@/hooks/use-board';
import { ArticleType } from '@/services/types/article.type';
import Link from 'next/link';
import EventCard from './components/event-card';

// 이벤트
export default function Client() {
  return (
    <ListContainer
      type={ArticleType.EVENT}
      limit={9}
      // render={({ items, page, totalPages, onPageChange, headerItem }) => {
      render={({ items, page, totalPages, onPageChange }) => {
        return (
          <>
            {/* {headerItem && <EventHeader {...headerItem} />} */}

            <div className="desktop:gap-4 flex flex-col gap-2 overflow-hidden rounded-lg">
              {eventPromotionBannerData.map((item) => (
                <div key={item.href}>
                  {/**웹 */}
                  <Link href={item.href} className="desktop:block hidden">
                    <ImageOptimizer
                      src={item.imgUrl || ''}
                      alt={item.label}
                      width={1180}
                      height={240}
                      className="object-cover"
                    />
                  </Link>
                  {/**모바일 */}
                  <Link
                    href={item.href}
                    className="desktop:hidden relative w-full"
                  >
                    <ImageOptimizer
                      src={item.mobileImgUrl || ''}
                      alt={item.label}
                      width={326}
                      height={192}
                      className="h-auto w-full object-cover"
                    />
                  </Link>
                </div>
              ))}
            </div>

            <div className="desktop:my-20 my-14">
              <PoliceLineDivider />
            </div>
            <h1 className="text-level-2 typo-28 desktop:typo-50 font-black">
              {/* {EventBreadcrumbItem.label} */}
              상시 이벤트
            </h1>
            <div className="desktop:grid desktop:grid-cols-3 desktop:mt-12 desktop:gap-8 mt-14 flex flex-col gap-10">
              {items.map((item) => (
                <EventCard {...item} key={item.id} />
              ))}
            </div>
            <Pagination
              page={page}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </>
        );
      }}
    />
  );
}
